export function PersonalInformationThirdParty() {
  return (
    <>
      <main>
        <p>
          주식회사 카카오엔터테인먼트는 이용자(본인)가 보유하고 있는 포인트를
          조회하여 캐시 충전(전환)을 할 수 있도록 (주)핏콜라보에 다음과 같은
          정보를 제공하는 것에 동의합니다. 개인정보 제공에 대한 동의를 거부할
          권리가 있으며, 동의를 거부할 경우 ‘TV포인트 회원 여부’ 및 ‘TV포인트
          조회, 사용’이 불가하오니 이점 양해를 부탁 드립니다.
        </p>
        <table
          cellSpacing="0"
          cellPadding="0"
          className="text-theme-solid-100 [&_td]:text-center! [&_th]:text-center!"
        >
          <colgroup>
            <col width="31%" />
            <col width="23%" />
            <col width="23%" />
            <col width="23%" />
          </colgroup>
          <tbody>
            <tr>
              <th>제공받는 자</th>
              <th>제공 목적</th>
              <th>제공 항목</th>
              <th>보유 및 이용 기간</th>
            </tr>
            <tr>
              <td className="text-[1.2em]">
                <strong>(주)핏콜라보</strong>
              </td>
              <td className="text-[1.2em]">
                <strong>TV포인트 회원여부 확인 및 TV포인트 조회, 사용</strong>
              </td>
              <td>CI(암호화된 본인식별 정보)</td>
              <td className="text-[1.2em]">
                <strong>제휴 서비스 종료 시까지</strong>
              </td>
            </tr>
          </tbody>
        </table>
      </main>
    </>
  );
}
